// extracted by mini-css-extract-plugin
module.exports = {"modale":"MapDataModal_modale__3Mlut","content":"MapDataModal_content__1EnO3","containerButtons":"MapDataModal_containerButtons__2t0Qw"};